var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStorage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.029 1.54059C9.32605 1.37563 9.66022 1.28906 10 1.28906C10.3398 1.28906 10.674 1.37563 10.971 1.54059L18.486 5.71459C18.6418 5.80123 18.7716 5.92795 18.862 6.08161C18.9524 6.23528 19 6.41032 19 6.58859V14.8236C18.9999 15.1802 18.9045 15.5304 18.7235 15.8377C18.5426 16.1451 18.2828 16.3984 17.971 16.5716L10.971 20.4616C10.674 20.6266 10.3398 20.7131 10 20.7131C9.66022 20.7131 9.32605 20.6266 9.029 20.4616L2.029 16.5716C1.71736 16.3985 1.45763 16.1453 1.27671 15.8381C1.0958 15.531 1.00026 15.1811 1 14.8246V6.58859C0.999993 6.41032 1.04764 6.23528 1.13802 6.08161C1.22839 5.92795 1.3582 5.80123 1.514 5.71459L9.03 1.54059H9.029Z",
    stroke: "url(#paint0_linear_708_4074)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8.5L14.5 3.5M4 11.328L7 13",
    stroke: "url(#paint1_linear_708_4074)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6L10 11M10 11L19 6M10 11V20.5",
    stroke: "#E87A46",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_708_4074",
    x1: 19,
    y1: 11.0011,
    x2: 0.999999,
    y2: 11.0011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B225F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E40E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_708_4074",
    x1: 14.5,
    y1: 8.25001,
    x2: 4,
    y2: 8.25001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B225F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E40E41"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/Storage.8171f4eb78d55c247b385534cc81a569.svg";
export { ForwardRef as ReactComponent };